import { FC, FormEvent, useState } from 'react'

import {
  BottomSheet,
  BottomSheetProps,
  Button,
  Header,
  Input,
} from '@revolut-internal/ui-kit'

import { Security } from 'modules/security/security'
import { NextIncidentAction } from 'types'

import { useIncidentActions } from './useIncidentActions'

type QueueHealthIncidentActionModalProps = BottomSheetProps & {
  action?: NextIncidentAction
}

const FORM_ID = 'incidents-action-form'

export const QueueHealthIncidentActionModal: FC<QueueHealthIncidentActionModalProps> = ({
  open,
  action,
  onClose,
}) => {
  const [note, setNote] = useState<string>()

  const {
    completeIncidentAction,
    skipIncidentAction,

    isCompleteActionPending,
    isSkipActionPending,
  } = useIncidentActions()

  const handleSkipAction = async () => {
    if (!action) {
      return
    }

    await skipIncidentAction({
      incidentActionId: action.incidentActionId,
      body: {
        notes: note,
      },
    })
    onClose?.()
  }

  const handleCompleteAction = async (event: FormEvent) => {
    event.preventDefault()

    if (!action) {
      return
    }

    await completeIncidentAction({
      incidentActionId: action.incidentActionId,
      body: {
        notes: note,
      },
    })
    onClose?.()
  }

  return (
    <BottomSheet open={open} onClose={onClose} onExited={() => setNote(undefined)}>
      {action && (
        <>
          <Header variant="compact">
            <Header.CloseButton aria-label="Close" />
            <Header.Title>{action.label} triggered</Header.Title>
          </Header>

          <form id={FORM_ID} onSubmit={handleCompleteAction}>
            <Input
              label="Outcome (optional)"
              value={note}
              onChange={event => setNote(event.currentTarget.value)}
            />
          </form>

          <BottomSheet.Actions horizontal>
            {Security.canSkipIncidentAction && (
              <Button
                type="submit"
                variant="secondary"
                pending={isSkipActionPending}
                onClick={handleSkipAction}
              >
                Skip
              </Button>
            )}
            <Button
              type="submit"
              variant="primary"
              form={FORM_ID}
              pending={isCompleteActionPending}
              elevated
            >
              Submit
            </Button>
          </BottomSheet.Actions>
        </>
      )}
    </BottomSheet>
  )
}
